import React from 'react';
import { FileText, Calculator } from 'lucide-react';
import ContactForm from '../forms/ContactForm';

const KtpnHero: React.FC = () => {
  return (
    <section className="relative overflow-hidden">
      {/* Фоновое видео на всю ширину и высоту 75vh */}
      <div className="absolute top-0 left-0 w-screen h-[75vh] max-h-[75vh] z-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover"
        >
          <source src="/videos/0605.mp4" type="video/mp4" />
          Ваш браузер не поддерживает видео.
        </video>
        <div className="absolute inset-0 bg-primary-900/10" />
      </div>

      {/* Контент */}
      <div className="relative z-10 flex items-center justify-center" style={{ minHeight: '75vh' }}>
        <div className="container-custom w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Левая колонка: текст */}
            <div className="text-center lg:text-left">
              <h1 className="text-4xl md:text-5xl font-extrabold leading-tight mb-4">
                КТПН — надёжные подстанции для вашего объекта под ключ
              </h1>
              <p className="text-lg text-primary-100 mb-8">
                Комплектные трансформаторные подстанции (КТПН) для промышленности, строительства и энергетики. Собственное производство, готовность от 50 дней, доставка по РФ и СНГ.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
                <a
                  href="#contact-form-main"
                  className="btn-primary w-full sm:w-auto flex items-center justify-center"
                >
                  <FileText className="w-5 h-5 mr-2" />
                  Запросить КП
                </a>
                <a
                  href="#contact-form-main"
                  className="btn-outline w-full sm:w-auto flex items-center justify-center text-white border-white hover:bg-white hover:text-primary-700"
                >
                  <Calculator className="w-5 h-5 mr-2" />
                  Получить расчёт
                </a>
              </div>
            </div>
            {/* Правая колонка: форма */}
            <div className="bg-white/10 backdrop-blur-sm p-6 md:p-8 rounded-xl shadow-2xl border border-white/20">
              <h3 className="text-2xl font-bold mb-2 text-white">Получить предложение</h3>
              <p className="text-primary-200 mb-6">Оставьте заявку, и мы свяжемся с вами в течение 15 минут.</p>
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KtpnHero; 